<script lang="ts">
import { defineComponent, PropType } from "vue";
import KlereoRadio from "@/shared/components/KlereoRadio.vue";
import { OutDef, outsByName } from "@/shared/utils/outs";
import RecurrencePicker from "@/shared/components/RecurrencePicker.vue";
import KlereoSlider from "@/shared/components/KlereoSlider.vue";
import { injectOut } from "@/shared/utils/injection";
import OnOffToggle from "@/features/out/OnOffToggle.vue";
import AutoOffPicker from "@/features/out/AutoOffPicker.vue";
import OutModePlans from "@/features/out/OutModePlans.vue";
import OutControlButton from "@/features/out/controls/OutControlButton.vue";
import getSpeedCount from "@/shared/utils/misc/get-speed-count";
import SpeedSelector from "@/features/out/controls/SpeedSelector.vue";

export default defineComponent({
  ...injectOut,
  components: {
    SpeedSelector,
    OutControlButton,
    AutoOffPicker,
    OnOffToggle,
    KlereoSlider,
    RecurrencePicker,
    OutModePlans,
    KlereoRadio,
  },
  emits: ["select"],
  props: {
    mode: {
      required: true,
      type: Object as PropType<OutDef["modes"][number]>,
    },
  },
  computed: {
    selected() {
      return this.out?.mode === this.mode.value;
    },
    speedCount() {
      if (this.out?.index === outsByName["OUT_FILTRE"].index) {
        return getSpeedCount(this.pool);
      }
      return 1;
    },
  },
});
</script>
<template>
  <div>
    <div @click="out.mode = mode.value" class="flex items-center">
      <klereo-radio :checked="selected" />
      <div class="text-lg font-medium ml-2.5 grow">
        {{ $t(mode.label!) }}
      </div>

      <div v-if="selected && mode.hasOnOff" class="flex items-center">
        <on-off-toggle
          v-if="speedCount === 1"
          :out="out"
          @change="(status) => (out.status = status)"
        ></on-off-toggle>
        <speed-selector
          v-if="speedCount > 1"
          :out="out"
          :speed-count="speedCount"
          @change="(status) => (out.status = status)"
        ></speed-selector>
      </div>

      <div
        v-if="selected && (mode.hasTrigger || mode.hasStop)"
        class="flex items-center"
      >
        <out-control-button
          :show-stop="mode.hasStop"
          :show-trigger="mode.hasTrigger"
        ></out-control-button>
      </div>
    </div>

    <div class="params" v-if="selected">
      <div v-if="mode.paramName" class="p-3">
        <div>
          <klereo-slider
            :min="mode!.paramRange![0]"
            :max="mode!.paramRange![1]"
            :initial="pool.params[mode.paramName!]"
            :precision="mode.paramPrecision"
            :unit="mode.paramUnit"
            @change="(value) => (pool.params[mode.paramName!] = value)"
          />
        </div>
      </div>

      <div v-if="mode.autoOffRange" class="p-3">
        <auto-off-picker :range="mode.autoOffRange" :unit="mode.paramUnit!" />
      </div>

      <div v-if="mode.hasRecurrence" class="p-3">
        <recurrence-picker
          :value="out.recurrence!"
          :with-time-mode="!!mode.filtrRecurrence"
        />
      </div>

      <out-mode-plans v-if="mode.planNames" :plan-names="mode.planNames" />
    </div>
  </div>
</template>
